import { Button, useTheme } from "@mui/material";
import { tokens } from "../../../../../theme";



export const ActionButton = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Button
            disabled={props.disabled ?? false}
            onClick={props.onClick}
            TouchRippleProps={{ 
                style: { 
                    color: theme.palette.mode === "dark" ? "rgba(255,255,255,.5)" : 'rgba(49, 65, 95, 0.5)' 
                } 
            }} // Directly styling the ripple here
            variant='contained'
            sx={{
                background:theme.palette.mode === "dark" ? colors.grey[100]  : "#fff",
                width:1,
                height:40,
                borderRadius:"8px",
                padding:0,
                minWidth:0,
                paddingX:1.5,
                display: "flex",
                alignItems:"center",
                justifyContent:"flex-start",
                textTransform:"none",
                minWidth:250,
                boxShadow: "none",
                opacity:1,
                "&:hover" : {
                    transition:"250ms",
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.bg["tertiary"],
                    boxShadow:"none"
                },
                ...props.sx
            }}
        >
            {props.children}

        </Button>
    );

}